// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expand-anim{overflow:hidden;transition:all .3s ease}.profile-nav-dropdown .nuxt-link-exact-active{--tw-bg-opacity:1;background-color:#f6f8fa;background-color:rgba(246,248,250,var(--tw-bg-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
